import { createFileRoute } from '@tanstack/react-router';
import { RootRedirect } from '@/features/account/shell/RootRedirect';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/')({
  component: RootRedirect,
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
